// @core/api/endpoints/notifications/process_delivery_confirmation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProcessDeliveryConfirmationRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Process delivery confirmation
 * Performs process operation on delivery confirmation.
 */
export async function ProcessDeliveryConfirmation(
  data: ProcessDeliveryConfirmationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/process_delivery_confirmation`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
